/* src/app/components/admin/cases/case-edit/case-edit.component.scss */
.row {
  padding-bottom: 10px;
}
.divider {
  padding-top: 10px;
}
.title {
  font-size: 10px;
  color: rgba(0, 0, 0, 0.54);
}
.link {
  color: -webkit-link;
  cursor: pointer;
  text-decoration: underline;
}
.mat-mdc-form-field-error {
  margin-top: -10px;
}
.gradient {
  animation-duration: 1.8s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: #f6f7f8;
  background:
    linear-gradient(
      to right,
      #fafafa 8%,
      #f4f4f4 38%,
      #fafafa 54%);
  background-size: 1000px 640px;
  position: relative;
}
:host-context(.dark-theme) .gradient {
  background:
    linear-gradient(
      to right,
      #393939 8%,
      #3c3c3c 38%);
}
:host-context(.dark-theme) .title {
  color: rgba(255, 255, 255, 0.6);
}
/*# sourceMappingURL=case-edit.component.css.map */
